import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
// import MovingBanner from "./components/MovingBanner/MovingBanner";

import Header from "./components/Header/Header";
import Topbar from "./components/Topbar/Topbar";

import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Fleet from "./pages/Fleet";
import Services from "./pages/Services";
import ServiceArea from "./pages/ServiceArea";
import Reservation from "./pages/Reservation";
import ContactUs from "./pages/ContactUs";
import Footer from "./components/Footer/Footer";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import BookRideCTA from "./components/BookRideCTA/BookRideCTA";
import { Toaster } from "react-hot-toast";


function App() {
  return (
    <HelmetProvider>

      <BrowserRouter>
        <Toaster position="top-center" />

        <ScrollToTop />
        {/* <MovingBanner /> */}

        <Header />

                <Topbar />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/gallery" element={<Fleet />} />
          <Route path="/services" element={<Services />} />
          <Route path="/service-areas" element={<ServiceArea />} />
          <Route path="/reservation" element={<Reservation />} />
          <Route path="/contact-us" element={<ContactUs />} />
        </Routes>

        <BookRideCTA />
        <Footer />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
